<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11B" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12B" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13B" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop14" :series="switchDataTop14" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop14" :series="switchDataTop14B" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop15" :series="switchDataTop15" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop15" :series="switchDataTop15B" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop16" :series="switchDataTop16" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop16" :series="switchDataTop16B" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-XL">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatus class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
          <SwitchStatus class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatus class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
          <SwitchStatus class="switch-item" :title="switchTitleTop25" :series="switchDataTop25" />
          <SwitchStatus class="switch-item" :title="switchTitleTop26" :series="switchDataTop26" />
        </div>
        <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleBottom2" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleBottom21" :series="switchDataBottom21" />
          <SwitchStatus class="switch-item" :title="switchTitleBottom22" :series="switchDataBottom22" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
          <SwitchStatus class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
          <SwitchStatus class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
          <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop39" :series="switchDataTop39" />
          <!-- <SwitchStatus class="switch-item" :title="switchTitleTop310" :series="switchDataTop310" />
          <SwitchStatus class="switch-item" :title="switchTitleTop311" :series="switchDataTop311" /> -->
          <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
          <SwitchStatus class="switch-item" :title="switchTitleTop42" :series="switchDataTop42" />
          <SwitchStatus class="switch-item" :title="switchTitleTop43" :series="switchDataTop43" />
          <SwitchStatus class="switch-item" :title="switchTitleTop44" :series="switchDataTop44" />
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station_main_wincc.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationIdList: "",
      stationName: "",
      stationIndex: "",
      dataSource: "",
      stationVentNameFix: "",
      sideName: "",
      stationTypeName: "",

      outputName1: "",
      outputName2: "",
      outputName3: "",
      outputName4: "",
      outputName5: "",
      outputName6: "",

      exitGasClampListDict: {
        "1出口": ["A1", "A2"],
      },

      switchDataTop11: null,
      switchDataTop11B: null,
      switchDataTop12: null,
      switchDataTop12B: null,
      switchDataTop13: null,
      switchDataTop13B: null,
      switchDataTop14: null,
      switchDataTop14B: null,
      switchDataTop15: null,
      switchDataTop15B: null,
      switchDataTop16: null,
      switchDataTop16B: null,

      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,
      switchDataTop25: null,
      switchDataTop26: null,

      switchDataBottom21: null,
      switchDataBottom22: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,
      switchDataTop39: null,
      switchDataTop310: null,
      switchDataTop311: null,

      switchDataTop41: null,
      switchDataTop42: null,
      switchDataTop43: null,

      deviceList: [],
    };
  },
  computed: {
    columnTitleTop1: function () {
      return this.sideName + "侧主缆送风机出口温湿度(" + this.dataSource + ")";
    },
    columnTitleTop2: function () {
      return this.sideName + "侧主缆管道风机(" + this.dataSource + ")";
    },
    columnTitleBottom2: function () {
      return this.sideName + "侧主缆散热风机(" + this.dataSource + ")";
    },
    columnTitleTop3: function () {
      return this.sideName + "侧主缆除湿机(" + this.dataSource + ")";
    },
    columnTitleTop4: function () {
      return this.sideName + "侧主缆空调(" + this.dataSource + ")";
    },

    switchTitleTop11: function () {
      return this.outputName1 + "送风机出口";
    },
    switchTitleTop12: function () {
      return this.outputName2 + "送风机出口";
    },
    switchTitleTop13: function () {
      return this.outputName3 + "送风机出口";
    },
    switchTitleTop14: function () {
      return this.outputName4 + "送风机出口";
    },
    switchTitleTop15: function () {
      return this.outputName5 + "送风机出口";
    },
    switchTitleTop16: function () {
      return this.outputName6 + "送风机出口";
    },

    switchTitleTop21: function () {
      return this.outputName1 + "送风机";
    },
    switchTitleTop22: function () {
      return this.outputName2 + "送风机";
    },
    switchTitleTop23: function () {
      return this.outputName3 + "送风机";
    },
    switchTitleTop24: function () {
      return this.outputName4 + "送风机";
    },
    switchTitleTop25: function () {
      return this.outputName5 + "送风机";
    },
    switchTitleTop26: function () {
      return this.outputName6 + "送风机";
    },

    switchTitleBottom21: function () {
      return "1#散热风机";
    },
    switchTitleBottom22: function () {
      return "2#散热风机";
    },

    switchTitleTop31: function () {
      return "主缆启停设定";
    },
    switchTitleTop32: function () {
      return "一级启停设定";
    },
    switchTitleTop33: function () {
      return "二级启停设定";
    },
    switchTitleTop34: function () {
      return "除湿机运行";
    },
    switchTitleTop35: function () {
      return "一级除湿";
    },
    switchTitleTop36: function () {
      return "二级除湿";
    },
    switchTitleTop37: function () {
      return "过滤器";
    },
    switchTitleTop38: function () {
      return "除湿机运行";
    },
    switchTitleTop39: function () {
      return "压差";
    },
    switchTitleTop310: function () {
      return "远程模式";
    },
    switchTitleTop311: function () {
      return "联动启停";
    },

    switchTitleTop41: function () {
      return "预冷前后温度";
    },
    switchTitleTop42: function () {
      return "预冷";
    },
    switchTitleTop43: function () {
      return "预冷高压";
    },
    switchTitleTop44: function () {
      return "压力低压";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    assembleExitGasClamp(exitName) {
      let gasClampName = "";
      if (exitName && this.exitGasClampListDict[exitName]) {
        let gasClampList = this.exitGasClampListDict[exitName];
        for (let gasClamp of gasClampList) {
          if (gasClampName !== "") {
            gasClampName += ", ";
          }
          gasClampName += gasClamp;
        }
      }

      let result = exitName + "连接气夹: " + gasClampName;
      return result;
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();

      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIdList = configJson[routerName].stationIdList;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
      this.sideName = configJson[routerName].sideName;
      this.stationTypeName = configJson[routerName].stationTypeName;
      this.dataSource = configJson[routerName].dataSource;

      this.outputName1 = configJson[routerName].outputName1;
      this.outputName2 = configJson[routerName].outputName2;
      this.outputName3 = configJson[routerName].outputName3;
      this.outputName4 = configJson[routerName].outputName4;
      this.outputName5 = configJson[routerName].outputName5;
      this.outputName6 = configJson[routerName].outputName6;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    reverseStatusValue(value) {
      if (value === 0) {
        return 1;
      } else if (value === 1) {
        return 0;
      } else {
        return value;
      }
    },
    getData() {
      // this.getLineChartData();

      let requestList = [];
      for (let stationId of this.stationIdList) {
        requestList.push(this.getCurrentData(stationId));
      }

      let currentData = {};
      this.$http.all(requestList).then(
        this.$http.spread((...resList) => {
          for (let res of resList) {
            Object.assign(currentData, res.data);
          }

          setTimeout(() => {
            this.loadingData = false;
          }, 500);

          const switchIdTop11T = this.findDeviceId(this.switchTitleTop11 + "温度");
          const switchIdTop11H = this.findDeviceId(this.switchTitleTop11 + "湿度");
          const switchIdTop11P = this.findDeviceId(this.switchTitleTop11 + "压力");
          const switchIdTop11F = this.findDeviceId(this.switchTitleTop11 + "流量");
          const switchIdTop12T = this.findDeviceId(this.switchTitleTop12 + "温度");
          const switchIdTop12H = this.findDeviceId(this.switchTitleTop12 + "湿度");
          const switchIdTop12P = this.findDeviceId(this.switchTitleTop12 + "压力");
          const switchIdTop12F = this.findDeviceId(this.switchTitleTop12 + "流量");
          const switchIdTop13T = this.findDeviceId(this.switchTitleTop13 + "温度");
          const switchIdTop13H = this.findDeviceId(this.switchTitleTop13 + "湿度");
          const switchIdTop13P = this.findDeviceId(this.switchTitleTop13 + "压力");
          const switchIdTop13F = this.findDeviceId(this.switchTitleTop13 + "流量");
          const switchIdTop14T = this.findDeviceId(this.switchTitleTop14 + "温度");
          const switchIdTop14H = this.findDeviceId(this.switchTitleTop14 + "湿度");
          const switchIdTop14P = this.findDeviceId(this.switchTitleTop14 + "压力");
          const switchIdTop14F = this.findDeviceId(this.switchTitleTop14 + "流量");
          const switchIdTop15T = this.findDeviceId(this.switchTitleTop15 + "温度");
          const switchIdTop15H = this.findDeviceId(this.switchTitleTop15 + "湿度");
          const switchIdTop15P = this.findDeviceId(this.switchTitleTop15 + "压力");
          const switchIdTop15F = this.findDeviceId(this.switchTitleTop15 + "流量");
          const switchIdTop16T = this.findDeviceId(this.switchTitleTop16 + "温度");
          const switchIdTop16H = this.findDeviceId(this.switchTitleTop16 + "湿度");
          const switchIdTop16P = this.findDeviceId(this.switchTitleTop16 + "压力");
          const switchIdTop16F = this.findDeviceId(this.switchTitleTop16 + "流量");

          this.switchDataTop11 = [
            {
              data: currentData[switchIdTop11T].value,
              isError: currentData[switchIdTop11T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop11H].value,
              isError: currentData[switchIdTop11H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop11B = [
            {
              data: currentData[switchIdTop11P].value,
              isError: currentData[switchIdTop11P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop11F].value,
              isError: currentData[switchIdTop11F].errorLevel,
              unit: "m³/h",
            },
          ];
          this.switchDataTop12 = [
            {
              data: currentData[switchIdTop12T].value,
              isError: currentData[switchIdTop12T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop12H].value,
              isError: currentData[switchIdTop12H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop12B = [
            {
              data: currentData[switchIdTop12P].value,
              isError: currentData[switchIdTop12P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop12F].value,
              isError: currentData[switchIdTop12F].errorLevel,
              unit: "m³/h",
            },
          ];
          this.switchDataTop13 = [
            {
              data: currentData[switchIdTop13T].value,
              isError: currentData[switchIdTop13T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop13H].value,
              isError: currentData[switchIdTop13H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop13B = [
            {
              data: currentData[switchIdTop13P].value,
              isError: currentData[switchIdTop13P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop13F].value,
              isError: currentData[switchIdTop13F].errorLevel,
              unit: "m³/h",
            },
          ];
          this.switchDataTop14 = [
            {
              data: currentData[switchIdTop14T].value,
              isError: currentData[switchIdTop14T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop14H].value,
              isError: currentData[switchIdTop14H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop14B = [
            {
              data: currentData[switchIdTop14P].value,
              isError: currentData[switchIdTop14P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop14F].value,
              isError: currentData[switchIdTop14F].errorLevel,
              unit: "m³/h",
            },
          ];
          this.switchDataTop15 = [
            {
              data: currentData[switchIdTop15T].value,
              isError: currentData[switchIdTop15T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop15H].value,
              isError: currentData[switchIdTop15H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop15B = [
            {
              data: currentData[switchIdTop15P].value,
              isError: currentData[switchIdTop15P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop15F].value,
              isError: currentData[switchIdTop15F].errorLevel,
              unit: "m³/h",
            },
          ];
          this.switchDataTop16 = [
            {
              data: currentData[switchIdTop16T].value,
              isError: currentData[switchIdTop16T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop16H].value,
              isError: currentData[switchIdTop16H].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop16B = [
            {
              data: currentData[switchIdTop16P].value,
              isError: currentData[switchIdTop16P].errorLevel,
              unit: "Pa",
            },
            {
              data: currentData[switchIdTop16F].value,
              isError: currentData[switchIdTop16F].errorLevel,
              unit: "m³/h",
            },
          ];

          const switchIdTop21 = this.findDeviceId(this.switchTitleTop21 + "运行");
          const switchIdTop21B = this.findDeviceId(this.switchTitleTop21 + "故障");
          const switchIdTop22 = this.findDeviceId(this.switchTitleTop22 + "运行");
          const switchIdTop22B = this.findDeviceId(this.switchTitleTop22 + "故障");
          const switchIdTop23 = this.findDeviceId(this.switchTitleTop23 + "运行");
          const switchIdTop23B = this.findDeviceId(this.switchTitleTop23 + "故障");
          const switchIdTop24 = this.findDeviceId(this.switchTitleTop24 + "运行");
          const switchIdTop24B = this.findDeviceId(this.switchTitleTop24 + "故障");
          const switchIdTop25 = this.findDeviceId(this.switchTitleTop25 + "运行");
          const switchIdTop25B = this.findDeviceId(this.switchTitleTop25 + "故障");
          const switchIdTop26 = this.findDeviceId(this.switchTitleTop26 + "运行");
          const switchIdTop26B = this.findDeviceId(this.switchTitleTop26 + "故障");
          this.switchDataTop21 = [
            {
              data: currentData[switchIdTop21B].value,
              isError: currentData[switchIdTop21B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop21].value,
              isError: currentData[switchIdTop21].errorLevel,
            },
          ];
          this.switchDataTop22 = [
            {
              data: currentData[switchIdTop22B].value,
              isError: currentData[switchIdTop22B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop22].value,
              isError: currentData[switchIdTop22].errorLevel,
            },
          ];
          this.switchDataTop23 = [
            {
              data: currentData[switchIdTop23B].value,
              isError: currentData[switchIdTop23B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop23].value,
              isError: currentData[switchIdTop23].errorLevel,
            },
          ];
          this.switchDataTop24 = [
            {
              data: currentData[switchIdTop24B].value,
              isError: currentData[switchIdTop24B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop24].value,
              isError: currentData[switchIdTop24].errorLevel,
            },
          ];
          this.switchDataTop25 = [
            {
              data: currentData[switchIdTop25B].value,
              isError: currentData[switchIdTop25B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop25].value,
              isError: currentData[switchIdTop25].errorLevel,
            },
          ];
          this.switchDataTop26 = [
            {
              data: currentData[switchIdTop26B].value,
              isError: currentData[switchIdTop26B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop26].value,
              isError: currentData[switchIdTop26].errorLevel,
            },
          ];

          const switchIdBottom21 = this.findDeviceId(this.switchTitleBottom21 + "运行");
          const switchIdBottom21B = this.findDeviceId(this.switchTitleBottom21 + "故障");
          const switchIdBottom22 = this.findDeviceId(this.switchTitleBottom22 + "运行");
          const switchIdBottom22B = this.findDeviceId(this.switchTitleBottom22 + "故障");
          this.switchDataBottom21 = [
            {
              data: currentData[switchIdBottom21B].value,
              isError: currentData[switchIdBottom21B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdBottom21].value,
              isError: currentData[switchIdBottom21].errorLevel,
            },
          ];
          this.switchDataBottom22 = [
            {
              data: currentData[switchIdBottom22B].value,
              isError: currentData[switchIdBottom22B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdBottom22].value,
              isError: currentData[switchIdBottom22].errorLevel,
            },
          ];

          const switchIdTop31 = this.findDeviceId(this.switchTitleTop31.replace("启停设定", "启动设定"));
          const switchIdTop31B = this.findDeviceId(this.switchTitleTop31.replace("启停设定", "停止设定"));
          const switchIdTop32 = this.findDeviceId(this.switchTitleTop32.replace("启停设定", "启动设定"));
          const switchIdTop32B = this.findDeviceId(this.switchTitleTop32.replace("启停设定", "停止设定"));
          const switchIdTop33 = this.findDeviceId(this.switchTitleTop33.replace("启停设定", "启动设定"));
          const switchIdTop33B = this.findDeviceId(this.switchTitleTop33.replace("启停设定", "停止设定"));
          const switchIdTop34 = this.findDeviceId(this.switchTitleTop34);
          const switchIdTop34B = this.findDeviceId(this.switchTitleTop34.replace("运行", "故障"));
          const switchIdTop34C = this.findDeviceId(this.switchTitleTop34.replace("运行", "报警"));
          const switchIdTop35 = this.findDeviceId(this.switchTitleTop35);
          const switchIdTop36 = this.findDeviceId(this.switchTitleTop36);
          const switchIdTop37 = this.findDeviceId("处理" + this.switchTitleTop37 + "堵塞");
          const switchIdTop37B = this.findDeviceId("再生" + this.switchTitleTop37 + "堵塞");
          const switchIdTop38 = this.findDeviceId(this.switchTitleTop38.replace("除湿机", "除湿") + "小时");
          const switchIdTop39 = this.findDeviceId(this.switchTitleTop39);
          //   const switchIdTop310 = this.findDeviceId(this.switchTitleTop310);
          //   const switchIdTop311 = this.findDeviceId(this.switchTitleTop311.replace("启停", "启动"));

          this.switchDataTop31 = [
            {
              data: currentData[switchIdTop31].value,
              isError: currentData[switchIdTop31].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop31B].value,
              isError: currentData[switchIdTop31B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop32 = [
            {
              data: currentData[switchIdTop32].value,
              isError: currentData[switchIdTop32].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop32B].value,
              isError: currentData[switchIdTop32B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop33 = [
            {
              data: currentData[switchIdTop33].value,
              isError: currentData[switchIdTop33].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop33B].value,
              isError: currentData[switchIdTop33B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop34 = [
            {
              data: currentData[switchIdTop34C].value,
              isError: currentData[switchIdTop34C].errorLevel,
              isZh: true,
              textOn: "警告",
            },
            {
              data: currentData[switchIdTop34B].value,
              isError: currentData[switchIdTop34B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop34].value,
              isError: currentData[switchIdTop34].errorLevel,
            },
          ];
          this.switchDataTop35 = {
            data: currentData[switchIdTop35].value,
            isError: currentData[switchIdTop35].errorLevel,
          };
          this.switchDataTop36 = {
            data: currentData[switchIdTop36].value,
            isError: currentData[switchIdTop36].errorLevel,
          };
          this.switchDataTop37 = [
            {
              data: currentData[switchIdTop37].value,
              isError: currentData[switchIdTop37].errorLevel,
              isZh: true,
              textOn: "处理",
            },
            {
              data: currentData[switchIdTop37B].value,
              isError: currentData[switchIdTop37B].errorLevel,
              isZh: true,
              textOn: "再生",
            },
          ];
          this.switchDataTop38 = {
            data: currentData[switchIdTop38].value,
            isError: currentData[switchIdTop38].errorLevel,
            isRunningTime: true,
            isHour: true,
          };
          this.switchDataTop39 = {
            data: currentData[switchIdTop39].value,
            isError: currentData[switchIdTop39].errorLevel,
            unit: "Pa",
          };
          //   this.switchDataTop310 = {
          //     data: currentData[switchIdTop310].value,
          //     isError: currentData[switchIdTop310].errorLevel,
          //     textOn: "远程",
          //     textOff: "就地",
          //   };
          //   this.switchDataTop311 = {
          //     data: currentData[switchIdTop311].value,
          //     isError: currentData[switchIdTop311].errorLevel,
          //     textOn: "启动",
          //     textOff: "停止",
          //   };

          const switchIdTop41 = this.findDeviceId(this.switchTitleTop41.replace("前后温度", "前温度"));
          const switchIdTop41B = this.findDeviceId(this.switchTitleTop41.replace("前后温度", "后温度"));
          const switchIdTop42 = this.findDeviceId(this.switchTitleTop42 + "运行");
          const switchIdTop42B = this.findDeviceId(this.switchTitleTop42 + "故障");
          const switchIdTop43 = this.findDeviceId(this.switchTitleTop43 + "正常");
          const switchIdTop44 = this.findDeviceId(this.switchTitleTop44 + "正常");

          this.switchDataTop41 = [
            {
              data: currentData[switchIdTop41].value,
              isError: currentData[switchIdTop41].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop41B].value,
              isError: currentData[switchIdTop41B].errorLevel,
              unit: "℃",
            },
          ];
          this.switchDataTop42 = [
            {
              data: currentData[switchIdTop42B].value,
              isError: currentData[switchIdTop42B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop42].value,
              isError: currentData[switchIdTop42].errorLevel,
            },
          ];

          this.switchDataTop43 = {
            data: this.reverseStatusValue(currentData[switchIdTop43].value),
            isError: currentData[switchIdTop43].errorLevel,
            isZh: true,
            textOn: "低压",
          };

          this.switchDataTop44 = {
            data: this.reverseStatusValue(currentData[switchIdTop44].value),
            isError: currentData[switchIdTop44].errorLevel,
            isZh: true,
            textOn: "低压",
          };
        })
      );
    },

    revertSwitchValue(input) {
      if (input === 0) {
        return 1;
      } else if (input === 1) {
        return 0;
      } else {
        return input;
      }
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-L {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 380px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-S {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 250px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XL {
    width: 100%;
    height: calc(75% - 7px);
    min-height: 430px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XS {
    width: 100%;
    height: calc(25% - 7px);
    min-height: 200px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-full {
    height: 100%;
    min-height: 635px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 4 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .switch-in-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-bottom: 5px;
  }

  .main-column-multi-line {
    width: calc(100% / 4 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .tooltip-slot {
    line-height: 1.4;
  }
}
</style>
